class Monitoring.Models.ContentBeautifier.RegexMatcher

  constructor: (@content) ->
    # nothing to do

  matches_of: (regex) ->
    plain_content = @plain_content()
    regex.exec(plain_content)

  plain_content: ->
    html = "<div>#{@content}</div>"
    doc = $(html)
    doc[0].innerText
